import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { Box } from "@chakra-ui/react";
import { ReservaFiltroTipoData } from "features/reservas/typings";

const { Option } = Select;

export interface SelectTipoDataReservasProps
  extends SelectProps<ReservaFiltroTipoData> {
  bg?: string;
  value?: ReservaFiltroTipoData;
  onChange: (v: any) => void;
  filterOptions?: any[];
  allowClear?: boolean;
}

function SelectTipoDataReservas({
  value,
  allowClear = false,
  ...rest
}: SelectTipoDataReservasProps) {
  return (
    <Box bg={rest.bg} rounded="6px" w="100%" minW={180}>
      <SelectBaseAntd
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Selecione"
        allowClear={allowClear}
        value={value}
        {...rest}
      >
        <Option value={ReservaFiltroTipoData.CriacaoReseva}>
          Data da Criação
        </Option>
        <Option value={ReservaFiltroTipoData.DataReserva}>
          Data da Reserva
        </Option>
      </SelectBaseAntd>
    </Box>
  );
}

export default SelectTipoDataReservas;
